module.exports = __webpack_public_path__ + "static/media/ic-4.5dbf4fc4.svg";